// import { useState, useEffect } from "react";
// import { useCurrency } from "../../Context/CurrencyContext";

// function NuAmount({
//   currency = "",
//   defaultCurrency = true,
//   value = 0,
// }) {
//   const { currencySymbol, currencySeparator } = useCurrency();
//   const [numberFormatLocale, setNumberFormatLocale] = useState("en-US");

//   useEffect(() => {
//     switch (currencySeparator) {
//       case "0,00,00,000.00": // India
//         setNumberFormatLocale("en-IN");
//         break;
//       case "00.000.000.00": // Germany, France
//         setNumberFormatLocale("de-DE"); // you can also try "fr-FR"
//         break;
//       case "00,000,000.00": // English-speaking Africa
//         setNumberFormatLocale("en-ZA"); // South Africa
//         break;
//       case "00,000,000.00":
//       case "00,000,000.00":
//       default:
//         setNumberFormatLocale("en-US");
//         break;
//     }
//   }, [currencySeparator]);

//   const formatValue = (val) => {
//     const parsedValue = parseFloat(val);
//     if (isNaN(parsedValue)) return "0.00";

//     return parsedValue.toLocaleString(numberFormatLocale, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//       useGrouping: true,
//     });
//   };

//   return (
//     <span>
//       {defaultCurrency
//         ? `${currency || currencySymbol || ""} ${formatValue(value)}`
//         : `${currency} ${formatValue(value)}`}
//     </span>
//   );
// }

// export default NuAmount;


import { useState, useEffect } from "react";
import { useCurrency } from "../../Context/CurrencyContext";

function NuAmount({
  currency = "",
  defaultCurrency = true,
  value = 0,
}) {
  const { currencySymbol, currencySeparator } = useCurrency();
  const [numberFormatLocale, setNumberFormatLocale] = useState("en-US");

  useEffect(() => {
    switch (currencySeparator) {
      case "0,00,00,000.00": // India
        setNumberFormatLocale("en-IN");
        break;
      case "00.000.000.00": // Germany, France
        setNumberFormatLocale("de-DE"); // you can also try "fr-FR"
        break;
      case "00,000,000.00": // English-speaking Africa
        setNumberFormatLocale("en-ZA"); // South Africa
        break;
      case "00,000,000.00":
      default:
        setNumberFormatLocale("en-US");
        break;
    }
  }, [currencySeparator]);

  const formatValue = (val) => {
    // Remove commas from the string before parsing
    const cleanedValue = val.toString().replace(/,/g, '');
    const parsedValue = parseFloat(cleanedValue);
    if (isNaN(parsedValue)) return "0.00";

    return parsedValue.toLocaleString(numberFormatLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    });
  };

  return (
    <span>
      {defaultCurrency
        ? `${currency || currencySymbol || ""} ${formatValue(value)}`
        : `${currency} ${formatValue(value)}`}
    </span>
  );
}

export default NuAmount;


// import { useState, useEffect } from "react";
// import { useCurrency } from "../../Context/CurrencyContext";

// function NuAmount({ currency = "", defaultCurrency = true, value = 0 }) {
//     const { currencySymbol } = useCurrency();
//     const [locale, setLocale] = useState('en-US'); // You can make locale dynamic if needed

//     useEffect(() => {
//         // Logic to set locale dynamically if required
//         // Example: setLocale(someDynamicLocale);
//     }, []);

//     const formatValue = (val) => {
//         const parsedValue = parseFloat(val);
//         if (isNaN(parsedValue)) return '0.00'; // Fallback if parsing fails

//         return parsedValue.toLocaleString(locale, { 
//             minimumFractionDigits: 2, 
//             maximumFractionDigits: 2 
//         });
//     };

//     return (
//         <span>
//             { defaultCurrency ? `${currency || currencySymbol || ""} ${formatValue(value)}` : `${currency} ${formatValue(value)}` }
//         </span>
//     );
// }

// export default NuAmount;
